import { render, staticRenderFns } from "./viewClassWork.vue?vue&type=template&id=e2c45854"
import script from "./viewClassWork.vue?vue&type=script&lang=js"
export * from "./viewClassWork.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports